import { server } from "../api";
import axios from "axios";
const GetLineData = async () => {
  try {
    let response = await axios.get(server + "line/data");
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const UpdateLine = async ({ id, name, URL, token_id, is_line_msg, channel_id, channel_secret, channel_token, is_tg, tg_groupid, usage, members, limit1, limit2, warn1, warn2, plan_usage, plan_members, warnings }) => {
  console.log({ id, name, URL, token_id, is_line_msg, channel_id, channel_secret, channel_token, is_tg, tg_groupid, usage, members, limit1, limit2, warn1, warn2, plan_usage, plan_members, warnings });
  let response = await axios.post(server + "line/update", {
    line_id: id,
    name: name,
    URL: (URL === undefined) ? '' : URL,
    token: (token_id === undefined) ? '' : token_id,
    is_line_msg, channel_id, channel_secret, channel_token, is_tg, tg_groupid, usage, members, limit1, limit2, warn1, warn2, plan_usage, plan_members, warnings
  });
  return response.data;
};
const CreateLine = async ({ name, URL, token_id, is_line_msg, channel_id, channel_secret, channel_token, is_tg, tg_groupid, limit1, limit2, warn1, warn2, usage, members, plan_usage, plan_members, warnings }) => {
  let response = await axios.post(server + "line/create", {
    name,
    URL: (URL === undefined) ? '' : URL,
    token: (token_id === undefined) ? '' : token_id,
    is_line_msg, channel_id, channel_secret, channel_token, is_tg, tg_groupid, limit1, limit2, warn1, warn2, usage, members, plan_usage, plan_members, warnings
  });
  return response.data;
};
const DeleteLine = async (id) => {
  let response = await axios({
    method: "DELETE",
    url: server + "line/delete",
    data: { line_id: id },
  });
  return response.data;
};
const GetSettings = async () => {
  try {
    let response = await axios.get(server + "settings");
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const UpdateSettings = async (line_message_text, usage_limit) => {
  let response = await axios.post(server + "settings", {
    id: 1, 'line_message_text': line_message_text, 'usage_limit': usage_limit
  });
  return response.data;
};

// V2 API
const GetAllLineDataV2 = async () => {
  try {
    let response = await axios.get(server + "line/v2/data");
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const GetLineDataV2 = async (id) => {
  try {
    let response = await axios.get(server + "line/v2/data/" + id);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const CreateLineV2 = async (data) => {
  try {
    let response = await axios.post(server + "line/v2/data", data);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const UpdateLineV2 = async (id, data) => {
  try {
    let response = await axios.put(server + "line/v2/data/" + id, data);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const DeleteLineV2 = async (id) => {
  try {
    let response = await axios.delete(server + "line/v2/data/" + id);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export default { GetLineData, UpdateLine, CreateLine, DeleteLine, GetSettings, UpdateSettings, GetAllLineDataV2, GetLineDataV2, CreateLineV2, UpdateLineV2, DeleteLineV2 };
